"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountRiskState = exports.isLiquidatingMode = exports.useCustomBalance = exports.useFPBalanceInfo = exports.useCustomAssets = exports.usePositionsList = exports.usePositionsWithFilter = exports.usePosition = exports.refreshAccountDetail = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../apis/FutureAPI");
const interface_1 = require("../../interface");
const FetchAssets = (params) => {
    const fetchData = (0, FutureAPI_1.queryFutureBalance)(params).pipe((0, operators_1.catchError)((err) => {
        console.log("/trade/account_detail error: " + (typeof err === "string" ? err : JSON.stringify(err)));
        if (err.code === "ECONNABORTED") {
            return rxjs_1.NEVER;
        }
        else {
            const info = {
                risk_state: interface_1.TraderAccountRiskState.TRADING,
                balances: [],
                positions: [],
                error: err,
            };
            return (0, rxjs_1.of)(info);
        }
    }));
    return (0, trade_utils_lib_1.getTradeDependencyInstance)()
        .getUserId()
        .pipe((0, operators_1.mergeMap)((userId) => {
        const modelParam = {
            keyId: "common_data",
            dataKey: "custom_assets_provider_" + (userId !== null && userId !== void 0 ? userId : "none"),
            expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
            refresh: () => fetchData,
        };
        return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
    }));
};
function processPosition(value, marginRate) {
    const { qty_long, qty_short = "", mark_price = "", amount_long = "", amount_short = "", amount_settle = "", leverage = 1, position_side, } = value;
    const markPrice = new trade_utils_lib_1.SafeDecimal(mark_price);
    const positionLeverage = leverage;
    const positionQty = new trade_utils_lib_1.SafeDecimal(qty_long).add(qty_short);
    const positionQtyABS = positionQty.abs();
    // 先简单的取绝对值
    const avgPrice = new trade_utils_lib_1.SafeDecimal(amount_long).add(amount_short).add(amount_settle).div(positionQty).abs();
    const diff = new trade_utils_lib_1.SafeDecimal(markPrice).sub(avgPrice);
    const positionValue = positionQtyABS.mul(markPrice);
    const profit = positionQty.mul(diff);
    const positionSide = position_side === interface_1.FuturePositionSide.LONG ? 1 : -1;
    const profitRate = diff.div(avgPrice).mul(positionLeverage).mul(positionSide);
    // FIX: 占用保证金不再直接使用后端返回的值，而是通过前端计算，计算公式为 占用保证金 = abs（持仓量*标记价格/杠杆倍数）
    // const initialMargin = new SafeDecimal(initial_margin);
    const initialMargin = positionValue.div(leverage);
    const amountSettle = new trade_utils_lib_1.SafeDecimal(amount_settle).mul(-1);
    return Object.assign(Object.assign({}, value), { positionValue: trade_utils_lib_1.NumberCommonUtils.toNormalPrice(positionValue), unrealizedPnl: trade_utils_lib_1.NumberCommonUtils.toNormalPrice(profit), unrealizedPnlRate: profitRate.toDecimalPlaces(4, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toString(), realizedPnl: amountSettle.toString(), avgPrice: avgPrice.toString(), positionQuantity: positionQty.toString(), initialMargin: trade_utils_lib_1.NumberCommonUtils.toNormalPrice(initialMargin, 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL), marginRate });
}
function processBalance(balance) {
    const free = new trade_utils_lib_1.SafeDecimal(balance.free);
    const debts = new trade_utils_lib_1.SafeDecimal(balance.debts);
    const totalPNL = new trade_utils_lib_1.SafeDecimal(balance.unrealized_pnl);
    const marginUsed = new trade_utils_lib_1.SafeDecimal(balance.total_initial_margin);
    // available实际值 =free + debts + 总浮动盈亏 - 总占用保证金
    const avaMargin = free.add(debts).add(totalPNL).sub(marginUsed);
    return Object.assign(Object.assign({}, balance), { availableMargin: avaMargin.toString() });
}
/**
 * 获取trader账户的保证金率
 * @description 遍历trader账户的所有持仓并对占用保证金`maint_margin`进行求和,除以USDT币种的总权益`free+debts+unrealized_pnl`,计算当前账户的保证金率
 * @description 计算公式`sum(maint_margin)/(free+debts+unrealized_pnl)`
 * > 注意：当前持仓中的每个仓位展示的保证金率同一个值
 * @todo 处理多币种时计算保证金率
 * */
function getMarginRate(balance, positions) {
    if (!balance || !positions) {
        return "";
    }
    const { free, debts, unrealized_pnl } = balance;
    const maintMarginSum = positions.reduce((sum, item) => {
        return sum.add(item.maint_margin);
    }, new trade_utils_lib_1.SafeDecimal(0));
    const available = new trade_utils_lib_1.SafeDecimal(free).add(debts).add(unrealized_pnl).toString();
    return maintMarginSum.div(available).toString();
}
const createPublish = (params) => {
    return (0, rxjs_1.merge)((0, rxjs_1.timer)(0, 5000), params.subject).pipe((0, operators_1.switchMap)(() => {
        return FetchAssets(params).pipe((0, operators_1.map)((res) => {
            var _a, _b;
            const pBalanceMap = new Map();
            const pBalances = [];
            (_a = res === null || res === void 0 ? void 0 : res.balances) === null || _a === void 0 ? void 0 : _a.forEach((balance) => {
                const newB = processBalance(balance);
                pBalances.push(newB);
                pBalanceMap.set(balance.coin, newB);
            });
            const marginRate = getMarginRate(pBalanceMap.get("USDT"), res === null || res === void 0 ? void 0 : res.positions);
            const ps = [];
            const pMap = new Map();
            (_b = res === null || res === void 0 ? void 0 : res.positions) === null || _b === void 0 ? void 0 : _b.forEach((e) => {
                const pItem = processPosition(e, marginRate);
                ps.push(pItem);
                pMap.set(e.symbol, pItem);
            });
            const info = {
                riskState: res.risk_state,
                positions: ps,
                positionMap: pMap,
                balances: pBalances,
                balanceMap: pBalanceMap,
                requestError: res.error,
            };
            return info;
        }), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.of)(null);
        }), (0, operators_1.filter)((res) => !!res), (0, operators_1.map)((res) => res));
    }), (0, operators_1.publishBehavior)({
        riskState: interface_1.TraderAccountRiskState.TRADING,
        positions: [],
        balances: [],
        positionMap: new Map(),
        balanceMap: new Map(),
    }), (0, operators_1.refCount)());
};
const botTriggerSubject = new rxjs_1.Subject();
const futuresTriggerSubject = new rxjs_1.Subject();
const botAccountPublish$ = createPublish({ accountType: trade_utils_lib_1.AccountTradeType.bot, subject: botTriggerSubject });
const manualAccountPublish$ = createPublish({
    accountType: trade_utils_lib_1.AccountTradeType.trader,
    subject: futuresTriggerSubject,
});
/** 主动刷新assets */
const refreshAccountDetail = () => {
    botTriggerSubject.next(new Date().getTime());
    futuresTriggerSubject.next(new Date().getTime());
};
exports.refreshAccountDetail = refreshAccountDetail;
/** 注册单个币对的持仓 */
const usePosition = (symbol, active = true) => {
    const [value, setValue] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const sub = manualAccountPublish$.subscribe({
            next: (res) => {
                const v = res.positionMap.get(symbol);
                setValue(v);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [symbol, active]);
    return value;
};
exports.usePosition = usePosition;
/** 注册持仓列表  筛选逻辑 totalCount使用初始持仓总数 */
const usePositionsWithFilter = (curSymbol = "", active = true, filterFn) => {
    const positionData = (0, exports.usePositionsList)(curSymbol, active);
    const newPositionData = (0, react_1.useMemo)(() => {
        const temp = Object.assign({}, positionData);
        if (temp && temp.positions && filterFn) {
            const newPosition = temp.positions.filter(filterFn);
            temp.positions = newPosition;
        }
        return temp;
    }, [filterFn, positionData]);
    return newPositionData;
};
exports.usePositionsWithFilter = usePositionsWithFilter;
/** 注册持仓列表 根据当前币对进行排序 没有当前币种传空串 */
const usePositionsList = (curSymbol = "", active = true) => {
    const [value, setValue] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const sub = manualAccountPublish$
            .pipe((0, operators_1.map)((res) => {
            // 进行一次排序 当前币对在最上边, BTC ETH其次,
            let filterData = [];
            let curSymbolItem = undefined;
            let BTCItem = undefined;
            let ETHItem = undefined;
            res.positions.forEach((e) => {
                if (e.symbol === curSymbol) {
                    curSymbolItem = e;
                }
                else if (e.symbol.startsWith("BTC.")) {
                    BTCItem = e;
                }
                else if (e.symbol.startsWith("ETH.")) {
                    ETHItem = e;
                }
                else {
                    filterData.push(e);
                }
            });
            filterData.sort((a, b) => { var _a, _b; return Number((_a = b.updated_time) !== null && _a !== void 0 ? _a : 0) - Number((_b = a.updated_time) !== null && _b !== void 0 ? _b : 0); });
            if (ETHItem) {
                filterData.splice(0, 0, ETHItem);
            }
            if (BTCItem) {
                filterData.splice(0, 0, BTCItem);
            }
            if (curSymbolItem) {
                filterData.splice(0, 0, curSymbolItem);
            }
            return Object.assign(Object.assign({}, res), { positions: filterData });
        }))
            .subscribe({
            next: (res) => {
                const data = {
                    positions: res.positions,
                    positionMap: res.positionMap,
                    error: res.requestError,
                    totalCount: res.positions.length,
                };
                setValue(data);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [active, curSymbol]);
    return value;
};
exports.usePositionsList = usePositionsList;
/** 注册资产细节 */
const useCustomAssets = (accountType, active = true) => {
    const [data, setData] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const ob$ = accountType === trade_utils_lib_1.AccountTradeType.bot ? botAccountPublish$ : manualAccountPublish$;
        const sub = ob$.subscribe({
            next: (res) => {
                setData(res);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [active, accountType]);
    return data;
};
exports.useCustomAssets = useCustomAssets;
/** 手动下单需要的balance和position信息 */
const useFPBalanceInfo = (accountType, base, quote, active = true) => {
    const assets = (0, exports.useCustomAssets)(accountType, active);
    return (0, react_1.useMemo)(() => {
        const b = assets === null || assets === void 0 ? void 0 : assets.balanceMap.get(base);
        const q = assets === null || assets === void 0 ? void 0 : assets.balanceMap.get(quote);
        const p = assets === null || assets === void 0 ? void 0 : assets.positionMap.get(`${base}/${quote}`);
        return {
            baseBalance: b,
            quoteBalance: q,
            position: p,
            riskState: assets === null || assets === void 0 ? void 0 : assets.riskState,
        };
    }, [assets === null || assets === void 0 ? void 0 : assets.balanceMap, assets === null || assets === void 0 ? void 0 : assets.positionMap, assets === null || assets === void 0 ? void 0 : assets.riskState, base, quote]);
};
exports.useFPBalanceInfo = useFPBalanceInfo;
/** 注册单个币的持有信息 */
const useCustomBalance = (accountType, coin, active = true) => {
    const assets = (0, exports.useCustomAssets)(accountType, active);
    return (0, react_1.useMemo)(() => {
        const b = assets === null || assets === void 0 ? void 0 : assets.balanceMap.get(coin);
        const e = assets === null || assets === void 0 ? void 0 : assets.requestError;
        return {
            balance: b,
            error: e,
        };
    }, [assets === null || assets === void 0 ? void 0 : assets.balanceMap, assets === null || assets === void 0 ? void 0 : assets.requestError, coin]);
};
exports.useCustomBalance = useCustomBalance;
/**
 * 检测账户是否处于强平模式
 * @returns true 强平模式
 */
function isLiquidatingMode(state) {
    return [interface_1.TraderAccountRiskState.MERGING, interface_1.TraderAccountRiskState.LIQUIDATING, interface_1.TraderAccountRiskState.TAKEOVER].includes(state);
}
exports.isLiquidatingMode = isLiquidatingMode;
/**获取账户的风险等级以及是否强平
 * @returns riskState 风险等级
 * @returns isLiquidating 是否处于强平状态
 */
function useAccountRiskState(accountType, active = true) {
    const assets = (0, exports.useCustomAssets)(accountType, active);
    return (0, react_1.useMemo)(() => {
        const riskState = (assets === null || assets === void 0 ? void 0 : assets.riskState) || interface_1.TraderAccountRiskState.TRADING;
        return {
            riskState,
            isLiquidating: isLiquidatingMode(riskState),
        };
    }, [assets === null || assets === void 0 ? void 0 : assets.riskState]);
}
exports.useAccountRiskState = useAccountRiskState;
